/* eslint-disable import/prefer-default-export */

/**
 * This object contains the keys that can by found on the network config object.
 * Use these keys for accessing a network config value in a selector.
 *
 * @example
 * const selectSchedulePhoneNumber = (state) => {
 *  const networks = state[CONFIG_SLICE_NAME].values.NETWORKS;
 *
 *  const myNetwork = networks['mynetwork'];
 *  const myNetworkConfig = myNetwork.config;
 *  return myNetworkConfig[constants.config.networkConfigKeys.SCHEDULE_PHONE_NUMBER];
 * }
 *
 * @TODO Typescript: Once we have a pattern for typing the responses from the API, these keys should be inferred by the config response type schema.
 */
export const networkConfigKeys = {
  INDIVIDUAL_DEDUCTIBLE: 'individualDeductible',
  INDIVIDUAL_OUT_OF_POCKET_MAX: 'individualOutOfPocketMax',
  SCHEDULE_PHONE_NUMBER: 'schedulePhoneNumber',
  SCHEDULE_COPY: 'scheduleCopy',
  SHOW_TELEHEALTH: 'showTelehealth',
  SHOW_BOARD_CERTIFIED: 'showBoardCertified',
  SHOW_WHEELCHAIR_ACCESSIBLE: 'showWheelchairAccessible',
  SHOW_SERVICE_COST: 'showServiceCost',
  MEMBER_ID_LINK: 'memberIdLink',
  SHOW_BCBS_LINK: 'showBcbsLink',
  SHOW_PHONE_NUMBER: 'showPhoneNumber',
  IS_SURGERY_PLUS: 'isSurgeryPlus',
  SURGERY_PLUS_PHONE_NUMBER: 'surgeryPlusPhoneNumber',
  SHOW_CLIENT_FEATURED: 'showClientFeatured',
  LOGIN_NETWORK_NAME_VERSION: 1,
  ZOHO_MAILBOX_ADDRESS: 'zohoMailboxAddress',
  ZOHO_DEPARTMENT_ID: 'zohoDepartmentId',
  SUPPORT_NAME: 'supportName',
  SUPPORT_PHONE_NUMBER: 'supportPhoneNumber',
  SUPPORT_EMAIL: 'supportEmail',
  SHOW_CHAT: 'showChat',
  SHOW_CHAT_SCENARIO: 'showChatScenario',
  SHOW_CHAT_FEEDBACK: 'showChatFeedback',
  SHOW_AI_SEARCH: 'showAiSearch',
  LOGIN_IMAGE: 'loginImage',
  HEADER_IMAGE: 'headerImage',
  FEATURED_ACTIONS: 'featuredActions',
  VALID_SCORE_TIERS: 'validScoreTiers',
  SHOW_SUPPORT_TICKET_FORM: 'showSupportTicketForm',
  SHOW_ACCEPTING_NEW_PATIENTS: 'showAcceptingNewPatients',
  HAS_EXTERNAL_QUALITY: 'hasExternalQuality',
  COST_ESTIMATOR_LINK: 'costEstimatorLink',
  COST_ESTIMATOR_LINK_DESCRIPTION: 'costEstimatorLinkDescription',
  ENABLE_CIGNA_COST_LINK: 'enableCignaCostLink',
  SHOW_OUTCARE: 'showLgbtqCompetency',
  HAS_AVAILITY_COVERAGES_CONFIGURATION: 'hasAvailityCoveragesConfiguration',
} as const;

export type NetworkConfigKey = (typeof networkConfigKeys)[keyof typeof networkConfigKeys];

export const MAX_DAYS_BETWEEN_TERMS_ACCEPTANCE: number = 30; // after this number of days, the terms need to be accepted again
